import F7Event               from '../app/events/f7_event';
import PrimaryButton         from './primary_button';
import React                 from 'react';
import ResourceNotFoundImage from '../assets/images/resource-not-found.svg';


export default function ResourceNotFound({ action = 'See all contacts', tab = 'customers' }) {
  return (
    <div className="resource-error">
      <ResourceNotFoundImage className="resource-not-found__image"/>
      <h2>Oops, this page doesn’t exist.</h2>
      <div className="resource-error__cta">
        <PrimaryButton label={action} onClick={event => redirect({ event, tab })}/>
      </div>
    </div>
  );
}


function redirect({ event, tab }) {
  const { target } = event;
  target.dispatchEvent(new F7Event(app => navigateToTab({ app, tab })));
}


function navigateToTab({ app, tab }) {
  const businessID = getBusinessID(app);
  const path       = businessID ? `/${businessID}/${tab}` : '/';
  app.views.main.router.navigate(path);
}


function getBusinessID(app) {
  const route      = app?.views.main?.router.currentRoute;
  const params     = route?.params;
  const businessID = params?.businessID;
  return businessID;
}
